import { testimonials } from "@/mocks/comics";

export default function Testimonials() {
  return (
    <section className="bg-background-50 py-16 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="mx-auto max-w-2xl text-center">
          <p className="text-sm font-semibold uppercase tracking-widest text-primary-600">
            读者口碑
          </p>
          <h2 className="mt-3 font-heading text-3xl font-black text-foreground-950 md:text-4xl">
            他们这样爱上离线阅读
          </h2>
          <p className="mt-4 text-base text-foreground-600">
            来自通勤党、学生党、收藏控的真实反馈，也是我们持续打磨的动力。
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 gap-5 md:grid-cols-2">
          {testimonials.map((t) => (
            <figure
              key={t.name}
              className="flex flex-col rounded-lg border border-background-200 bg-background-100 p-6"
            >
              <div className="flex items-center gap-1 text-accent-500">
                {[1, 2, 3, 4, 5].map((n) => (
                  <i key={n} className="ri-star-fill text-base" aria-hidden="true"></i>
                ))}
              </div>
              <blockquote className="mt-4 flex-1 text-sm leading-relaxed text-foreground-700">
                “{t.content}”
              </blockquote>
              <figcaption className="mt-5 flex items-center gap-3">
                <span className="flex h-11 w-11 items-center justify-center rounded-full bg-primary-500 font-heading text-base font-bold text-background-50">
                  {t.initial}
                </span>
                <span>
                  <span className="block text-sm font-bold text-foreground-900">
                    {t.name}
                  </span>
                  <span className="block text-xs text-foreground-500">{t.role}</span>
                </span>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}